import * as React from 'react'

import { MobXProviderContext, observer } from 'mobx-react'

import useWorkflowsByIds from '~/client/src/shared/hooks/useWorkflowsByIds'
import Workflow from '~/client/src/shared/models/Workflow'

import LinkedWorkflowItem from './LinkedWorkflowItem'

// localization: no text to translate

interface IProps {
  workflowIds: string[]
  onWorkflowClick?: (workflow: Workflow) => void
  withAllDrafts?: boolean
}

const LinkedWorkflowViewList: React.FC<IProps> = observer(
  ({ workflowIds, onWorkflowClick, withAllDrafts = false }) => {
    const { state } = React.useContext(MobXProviderContext) as any
    const projectId = state.activeProject.id
    const { workflows } = useWorkflowsByIds(
      projectId,
      workflowIds,
      withAllDrafts,
    )

    if (!workflows?.length) {
      return null
    }

    return (
      <div className="tw:flex tw:flex-col tw:gap-2">
        {workflows.map((workflow, index) => (
          <LinkedWorkflowItem
            key={workflow.id || `workflow-${index}`}
            workflow={workflow}
            onClick={onWorkflowClick}
          />
        ))}
      </div>
    )
  },
)

export default LinkedWorkflowViewList
